var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmpty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 313.726,
    height: 261.604,
    viewBox: "0 0 313.726 261.604",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4382",
    "data-name": "Group 4382",
    transform: "translate(-803.137 -410.241)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Blank_canvas-bro_4_",
    "data-name": "Blank canvas-bro (4)",
    transform: "translate(778.057 341.062)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-48",
    transform: "translate(55.915 69.179)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8353",
    "data-name": "Path 8353",
    d: "M31.992,223.686s4.864,42.422,40.915,60.547,71.363.492,103.777-3.758c16.98-2.225,32.725,6.126,49.369,7.872,53.224,5.589,95-57.138,87.5-103.279-6.469-39.938-32.007-68.135-78.517-88.246s-78.5-36.108-132.524-17.207S28.143,168.741,31.992,223.686Z",
    transform: "translate(-31.537 -71.179)",
    fill: "#64b5f6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-48",
    transform: "translate(25.08 205.624)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_620",
    "data-name": "Line 620",
    x2: 290.781,
    transform: "translate(0 92.159)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1.056
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8355",
    "data-name": "Path 8355",
    d: "M431.938,300.466A16.319,16.319,0,0,0,424,305.34a34.469,34.469,0,0,0-4.8,6.542c-.873,1.49-1.667,3.037-2.391,4.6-.475,1.022-.83,2.306-1.277,3.47-.646,1.043-1.284,2.129-1.831,3.1,1.937-6.925,8.131-19.676,8.245-23.3.114-3.945-3.661,1.944-5.79,9.934a112.058,112.058,0,0,0-2.71,13.836c-.22.4-.419.8-.589,1.171-.383.809-1.043,2.185-1.923,3.974,1.873-5.882,2.625-12.871,1.462-13.744-1.674-1.249-2.285,1.824-2.285,7.486a49.483,49.483,0,0,1-2,11.906c-1.057,2.129-2.242,4.406-3.505,6.833,1.327-4.257,2.093-10.345,2.838-14.9,1.057-6.656.6-8.727-1.554-5.534s-1.774,7.805-1.263,13.481a23.637,23.637,0,0,1-1.923,10.586c-1.625,3.079-3.349,6.265-5.087,9.394a32.215,32.215,0,0,0,2.774-10.154c.745-7.7-.248-14.759-2.022-12.772s-.71,7.358-.93,13.872a73.467,73.467,0,0,1-1.384,11.807l-.532.937a31.866,31.866,0,0,0,.518-10.026c.355-1.291.234-2.129-.192-2.5-.064-1.419.057-3.626-.561-4.74-1.554-2.774-3.264.972-3.278,2.441a24.478,24.478,0,0,0,.234,3.377,8.664,8.664,0,0,0-1.561,1.917c-.234.39-.482.837-.71,1.313,0-.461.05-.93.071-1.419a6.833,6.833,0,0,0-.766-3.626,22.565,22.565,0,0,0,2.008-5.911,3.264,3.264,0,0,0-.177-2.051,1.675,1.675,0,0,0-2.483-.667c-2.959,1.568-3.754,5.336-4.08,8.359a51.708,51.708,0,0,1-1.54,7.684c-.61,2.278-1.135,4.342-1.483,5.747-.255-1.582-.568-3.122-.937-4.541-.326-1.249-.653-2.441-.965-3.6a24.026,24.026,0,0,1,2.384-12.176c3.5-7.181,6.024-10.544,3.6-10.7s-5.946,3.626-6.45,9.551a66.487,66.487,0,0,0-.227,10.813c-.766-2.76-1.526-5.357-2.32-8a17.555,17.555,0,0,1,.44-8.8c1.653-4.882,6.585-13.552,3.988-12.871s-5.712,5.712-6.06,11.033a29.259,29.259,0,0,0,.915,8.273c-.568-1.859-1.164-3.775-1.8-5.8-.277-.866-.561-1.788-.844-2.732a2.936,2.936,0,0,0-.071-.482,13.481,13.481,0,0,1,1.419-8c2.476-4.463,7.1-8.295,4.364-9.316s-6.84,6.237-7.1,9.87a17.485,17.485,0,0,0,.333,4.115c-.106-.277-.22-.561-.333-.844-.589-2.079-1.157-4.137-1.653-5.96a16.511,16.511,0,0,1,1.568-7.805c2.427-5.549,5.506-11.913,2.363-10.3-2.533,1.313-5.279,8.806-4.733,15.135-.22-.823-.4-1.54-.561-2.129-.412-3.626-1.192-12.162,0-17.249.781-3.4,2.051-6.606,2.448-10.1a2.186,2.186,0,0,0-.057-1.071c-.844-2.129-3.59,1.987-4.037,2.661a16.32,16.32,0,0,0-2.5,9,34.616,34.616,0,0,0,.958,8.053,49.481,49.481,0,0,0,1.419,5c.348,1.071.965,2.249,1.419,3.406.234,1.2.5,2.42.781,3.512-3.314-6.386-7.486-19.931-9.884-22.656-2.6-2.966-1.341,3.924,2.561,11.218a111,111,0,0,0,7.4,11.977c.121.454.248.873.369,1.263.277.851.71,2.306,1.306,4.215-2.64-5.584-6.861-11.2-8.3-11.041-2.079.227-.433,2.888,3.434,7.025a48.45,48.45,0,0,1,6.663,10.076c.653,2.249,1.369,4.747,2.129,7.386-1.923-4-5.527-8.99-8.117-12.829-3.768-5.591-5.513-6.8-4.91-2.987s4.052,6.939,8.3,10.735a23.726,23.726,0,0,1,5.818,9.054c.908,3.356,1.831,6.861,2.689,10.338a31.83,31.83,0,0,0-4.9-9.316c-4.711-6.138-10.253-10.643-10.182-7.947s4.484,5.875,8.784,10.771a74.344,74.344,0,0,1,7.039,9.5c.078.355.163.71.248,1.05-1.965-3.548-4.967-6.386-7.975-9.054-1.05-.937-2.632-2.973-3.981-3.406-3.03-.972-1.724,2.93-.71,4.016,3.236,3.548,7.805,5.719,10.778,9.43a34.057,34.057,0,0,1,3.023,4.47q.312,1.831.49,3.427c-1.142-1.142-3.448-2.973-3.612-3.087-3.661-2.462-5.776-5.832-8.586-9.075-.844-.979-2.285-2.171-3.64-2.228-1.887-.092-2.491,1.93-1.958,3.512,2.214,6.535,10.551,6.819,15.468,10.218a14.091,14.091,0,0,1,2.469,2,42.1,42.1,0,0,1,.163,6.067H370.434v4.683h3.342l2.682,16.674h22.457l2.711-16.674h3.342v-4.683H388.095c.773-.93,1.6-1.944,2.427-3.016l3.548.106s12.332.539,16.866-1.895.49-4.789-3.839-3.548-12.85,5.1-14.73,5.045l-1.6-.043c.88-1.142,1.76-2.341,2.6-3.548a80.886,80.886,0,0,0,10.054-3.179c3.548-1.419,7.663-2.54,10.714-4.91a3.229,3.229,0,0,0,1.27-1.618,1.675,1.675,0,0,0-1.355-2.185c-3.236-.873-6.386,1.341-8.692,3.321a50.568,50.568,0,0,1-6.386,4.57c-2,1.249-3.789,2.4-5.009,3.193.894-1.334,1.724-2.668,2.42-3.959.61-1.135,1.192-2.228,1.753-3.292a24.082,24.082,0,0,1,10.054-7.273c7.464-2.838,11.6-3.6,9.934-5.364s-6.826-1.419-11.232,2.583a66.793,66.793,0,0,0-7.55,7.748c1.32-2.54,2.54-4.967,3.768-7.429a17.412,17.412,0,0,1,6.322-6.13c4.534-2.441,14.056-5.414,11.693-6.684s-8.068.27-11.949,3.931a28.845,28.845,0,0,0-4.967,6.67c.852-1.753,1.724-3.548,2.64-5.471.39-.823.809-1.682,1.249-2.569l.277-.4a13.431,13.431,0,0,1,6.5-4.882c4.853-1.568,10.849-1.213,9.551-3.824s-9.26-.106-11.906,2.384a17.739,17.739,0,0,0-2.569,3.236c.114-.277.227-.561.333-.851.986-1.916,1.973-3.8,2.838-5.478a16.561,16.561,0,0,1,6.471-4.626c5.556-2.405,12.155-4.967,8.749-5.911-2.746-.781-9.863,2.838-13.786,7.805.4-.752.752-1.419,1.036-1.923,2.171-2.938,7.429-9.707,11.757-12.623,2.888-1.951,6-3.434,8.678-5.676a2.129,2.129,0,0,0,.71-.83C437.529,299.153,432.726,300.274,431.938,300.466Zm-50.293,58.275c.71-1.107,2.008-3.15,3.42-5.783a33.588,33.588,0,0,0,1.49,3.484c-1.313,2.682-2.5,5.009-3.193,5.613l-1.228,1.057c-.106-1.433-.277-2.916-.49-4.371Zm8.181,7.77c-1.029,1.327-1.973,2.42-2.838,3.335H382.61c-.071-1.781-.192-3.973-.4-6.315l2.668-2.349s1.171-1,2.76-2.5a22.663,22.663,0,0,1,1.753,4.69A14.455,14.455,0,0,1,389.826,366.511Zm3.633-9.224a33.92,33.92,0,0,1-.844,5.322q-1.022,1.554-1.98,2.838a46.424,46.424,0,0,0-.539-4.719,20.578,20.578,0,0,1-.49-3.981,52.515,52.515,0,0,0,3.64-4.066,22.751,22.751,0,0,1,.241,4.591Z",
    transform: "translate(-138.816 -283.477)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Canvas--inject-48",
    transform: "translate(122.281 90.048)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_434",
    "data-name": "Ellipse 434",
    cx: 66.591,
    cy: 11.168,
    rx: 66.591,
    ry: 11.168,
    transform: "translate(0 218.399)",
    fill: "#64b5f6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_435",
    "data-name": "Ellipse 435",
    cx: 66.591,
    cy: 11.168,
    rx: 66.591,
    ry: 11.168,
    transform: "translate(0 218.399)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8356",
    "data-name": "Path 8356",
    d: "M303.909,377.283H222.68l.972-7.273h78.8Z",
    transform: "translate(-196.703 -148.786)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.056
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8357",
    "data-name": "Path 8357",
    d: "M331.076,349.086h8.238l-37.819-228.5H293.25Z",
    transform: "translate(-232.108 -120.59)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.056
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8358",
    "data-name": "Path 8358",
    d: "M210.595,349.086H202.35l37.344-228.5h8.238Z",
    transform: "translate(-176.373 -120.59)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.056
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1340",
    "data-name": "Rectangle 1340",
    width: 33.704,
    height: 5.095,
    transform: "translate(49.739 132.48)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.056
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1341",
    "data-name": "Rectangle 1341",
    width: 50.371,
    height: 5.095,
    transform: "translate(41.409 4.612)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.056
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1342",
    "data-name": "Rectangle 1342",
    width: 99.408,
    height: 118.176,
    transform: "translate(16.646 9.458)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.056
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1343",
    "data-name": "Rectangle 1343",
    width: 111.045,
    height: 5.818,
    transform: "translate(11.069 127.144)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.056
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.3abea6f57ddbf2d38367af3590f14bb5.svg";
export { ForwardRef as ReactComponent };